import React from 'react';
import TestResultDisplay from '../common/TestResultDisplay';

// 社会照护测试响应数据接口
interface SocialCareResponses {
  home_environment?: boolean;
  financial_situation?: boolean;
  social_isolation?: boolean;
  social_engagement?: boolean;
}

interface SocialCareTestResultProps {
  responses: SocialCareResponses;
  riskAreas: string[];
  className?: string;
}

const SocialCareTestResult: React.FC<SocialCareTestResultProps> = ({
  responses,
  riskAreas,
  className = ''
}) => {
  // 🚨 调试标记 - SocialCareTestResult 组件已加载 🚨
  console.log('🚨🚨🚨 SocialCareTestResult 组件已加载 - 2025-08-30 🚨🚨🚨');
  console.log('🔥 传入的responses数据:', responses);
  console.log('🔥 riskAreas:', riskAreas);

  // 社会照护四个维度的评估
  const homeEnvSafe = !responses.home_environment;
  const financialStable = !responses.financial_situation;
  const notIsolated = !responses.social_isolation;
  const sociallyEngaged = !responses.social_engagement;
  

  const testGroups = [
    {
      title: '居住环境评估',
      passed: homeEnvSafe,
      items: [
        {
          name: '居住环境',
          passed: homeEnvSafe,
          userAnswer: homeEnvSafe ? '住房无问题' : '住房有问题'
        }
      ]
    },
    {
      title: '经济状况评估',
      passed: financialStable,
      items: [
        {
          name: '经济状况',
          passed: financialStable,
          userAnswer: financialStable ? '经济状况稳定' : '经常资金不足'
        }
      ]
    },
    {
      title: '社会关系评估',
      passed: notIsolated,
      items: [
        {
          name: '孤独感',
          passed: notIsolated,
          userAnswer: notIsolated ? '不感到孤独' : '经常感到孤独'
        }
      ]
    },
    {
      title: '社会参与评估',
      passed: sociallyEngaged,
      items: [
        {
          name: '活动参与',
          passed: sociallyEngaged,
          userAnswer: sociallyEngaged ? '能正常参与活动' : '难以参与活动'
        }
      ]
    }
  ];

  const passedCount = [homeEnvSafe, financialStable, notIsolated, sociallyEngaged].filter(Boolean).length;

  return (
    <TestResultDisplay
      title="社会照护评估结果"
      subtitle={`综合评估: ${passedCount}/4个维度正常`}
      testGroups={testGroups}
      className={className}
    />
  );
};

export default SocialCareTestResult;